var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.7497H8C4.7 22.7497 4.25 20.9497 4.25 18.9997V10.2197C4.25 9.80973 4.59 9.46973 5 9.46973C5.41 9.46973 5.75 9.80973 5.75 10.2197V18.9997C5.75 20.7397 6.05 21.2497 8 21.2497H17C18.95 21.2497 19.25 20.7397 19.25 18.9997V10.2197C19.25 9.80973 19.59 9.46973 20 9.46973C20.41 9.46973 20.75 9.80973 20.75 10.2197V18.9997C20.75 20.9497 20.3 22.7497 17 22.7497Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.75H5.5C3.08 10.75 1.75 9.42 1.75 7V5C1.75 2.58 3.08 1.25 5.5 1.25H19.5C21.92 1.25 23.25 2.58 23.25 5V7C23.25 9.42 21.92 10.75 19.5 10.75ZM5.5 2.75C3.92 2.75 3.25 3.42 3.25 5V7C3.25 8.58 3.92 9.25 5.5 9.25H19.5C21.08 9.25 21.75 8.58 21.75 7V5C21.75 3.42 21.08 2.75 19.5 2.75H5.5Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.32 14.75H10.68C10.27 14.75 9.92999 14.41 9.92999 14C9.92999 13.59 10.27 13.25 10.68 13.25H14.32C14.73 13.25 15.07 13.59 15.07 14C15.07 14.41 14.73 14.75 14.32 14.75Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/Files.4da6a0b1.svg";
export { ForwardRef as ReactComponent };